import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, TCard, H2, BODY } from "../shared";
import treppeImg from "@/assets/img/luisa-treppe.jpeg";
import karinImg from "@/assets/img/t-karin.jpg";

export default function BioSection() {
  return (
    <Section testId="bio-section" className="bg-gold py-24 md:py-36">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <Reveal>
            <div className="relative">
              <div className="absolute -inset-3 -z-10 bg-cognac-2/15" />
              <img src={treppeImg} alt="Porträt von Luisa Bergholz auf einer Steintreppe" width="1028" height="1701" className="w-full object-cover" loading="lazy" />
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <SectionLabel color="espresso" testId="bio-label">Deine Mentorin und Coach</SectionLabel>
          <Reveal>
            <h2 className={`${H2} mb-4 text-4xl md:text-6xl`}>Luisa Bergholz</h2>
          </Reveal>
          <Reveal delay={0.05}>
            <p className="mb-8 font-body text-base uppercase tracking-[0.12em] text-cognac-2">
              Arbeitspsychologin · Expertin für berufliche Neuorientierung · Projektorin · Dolce-Vita-Genießerin
            </p>
          </Reveal>
          <div className="space-y-6">
            <Reveal delay={0.08}>
              <p className={BODY}>Ich glaube nicht, dass wir uns zwischen Erfolg und Erfüllung entscheiden müssen.</p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className={BODY}>
                Ich habe selbst lange nach den alten Regeln gespielt, war Meisterin darin, sie brav zu befolgen – sogar als Selbstständige noch. Bis ich anfing, mich zu fragen: <em className="text-cognac-2">Wer hat eigentlich gesagt, dass Arbeit so aussehen muss?</em>
              </p>
            </Reveal>
            <Reveal delay={0.12}>
              <p className={BODY}>
                Mein Job, mein Arbeitgeber war nie verantwortlich dafür, dass es mir schlecht ging. Das, was die Erschöpfung erschafft, hat wenig mit der Arbeit an sich zu tun, sondern damit, wie ich mich führe.
              </p>
            </Reveal>
            <Reveal delay={0.14}>
              <p className={BODY}>
                Seit 2018 sauge ich wie besessen alles auf, was mir zu dem Thema in die Finger kommt – New Work, Coaching, Neurowissenschaften, Kreativitätstechniken, Nervensystemregulation, Manifestieren, Identitätsarbeit, Embodiment. You name it.
              </p>
            </Reveal>
            <Reveal delay={0.16}>
              <p className={BODY}>
                Allein in den letzten 5 Jahren habe ich über 100.000 € in meine Entwicklung bei unterschiedlichsten Mentor:innen und Coaches investiert. Meine Coaching-Skills in tausenden von Coachingstunden verfeinert.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className={BODY}>
                Aus allem, was wirklich funktioniert, kreiere ich für Dich und mit Dir <strong style={{ fontWeight: 700 }}>Unverschämt Erfolgreich</strong> – damit Du nicht all die Fehler und Umwege machen brauchst, die ich unterwegs gemacht hab.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className={`${BODY} italic text-cognac-2`}>
                Inzwischen lebe ich ein Leben, in dem sich meine Arbeit auf natürliche Weise einfügt. In dem ich keinen Urlaub von meiner Arbeit „brauche“. Und gleichzeitig so viel reise und das Leben genieße wie nie zuvor.
              </p>
            </Reveal>
          </div>
          <Reveal delay={0.22}>
            <div className="mt-12">
              <TCard
                img={karinImg}
                name="Karin"
                lead="Ich stehe in einem völlig anderen Bereich im neuen Job und fühle mich richtig angekommen. Absolute Herzensempfehlung!"
                ps={[
                  "Luisa hat mich genau da abgeholt, wo ich stand – diffus energielos und überzeugt, dass ich zum aktuellen Zeitpunkt durch Rahmenbedingungen wie Teilzeit und berufsbegleitendes Studium nichts ändern könne, mit leisen Zweifeln, ob das Programm denn wirklich das Richtige für mich sei – und mich in sehr kurzer Zeit vollkommen begeistert!",
                  "Neben der großen beruflichen Veränderung gibt es noch unzählige kleine Dinge im Alltag, die mich immer wieder an die Erkenntnisse der Zeit mit Luisa erinnern und so meine Energie und Motivation nachhaltig steigern.",
                ]}
                testId="testimonial-karin"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
